<template>
  <div class="wrapper mask-wave-arc my-12">
    <div tabindex="0" @keyup.left="prev" @keyup.right="next">
      <div class="bg-white pt-28 pb-8">
        <slot name="header" />
        <div class="carousel-list-wrapper relative">
          <button v-show="showLeftArrow" class="arrow -left-5" @click="prev">&lsaquo;</button>
          <button v-show="showRightArrow" class="arrow -right-5" @click="next">&rsaquo;</button>
          <div class="carousel-list flex items-center overflow-auto" ref="scroller">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import debounce from 'lodash/debounce'

const CARD_SIZE = 320

const showLeftArrow = ref(false)
const showRightArrow = ref(false)
const scroller = useTemplateRef('scroller')

const changeHandler = debounce(updateControls, 300)

onMounted(() => {
  if (!scroller.value) {
    return
  }
  updateControls()
  window.addEventListener('resize', changeHandler)
  scroller.value.addEventListener('scroll', changeHandler)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', changeHandler)
})

function updateControls() {
  if (!scroller.value) {
    return
  }
  const { scrollWidth, scrollLeft, clientWidth } = scroller.value
  const isOverflowing = scrollWidth > clientWidth
  const isEnd = scrollLeft + clientWidth === scrollWidth
  showLeftArrow.value = scrollLeft > 0
  showRightArrow.value = isOverflowing && !isEnd
}

function prev() {
  scroll(CARD_SIZE * -1)
}

function next() {
  scroll(CARD_SIZE)
}

function scroll(position: number) {
  if (scroller.value) {
    scroller.value.scrollLeft += position
  }
}
</script>

<style scoped>
.wrapper {
  max-width: 100vw;
}

.carousel-list {
  padding: theme('spacing.14') calc((100% - var(--container-max-width)) / 2) 0;
  scroll-behavior: smooth;
  scrollbar-width: none;
}

.carousel-list::-webkit-scrollbar {
  display: none;
}

.carousel-list-wrapper:hover .arrow {
  @apply block;
}

.arrow {
  @apply absolute text-gray-700 text-50 font-bold top-1/2 w-16 h-16 bg-white rounded-full shadow-1 z-40 lg:hidden transition ease-in-out;
}

.arrow:active {
  @apply text-white bg-gray-600;
}
</style>
